import { styled } from '../theme';

const PageContainer = styled('div')<{ centered?: boolean }>(({ theme, centered }) => ({
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    height: '100%',
    position: 'relative',
    alignItems: centered ? 'center' : 'flex-start',
}));

export default PageContainer;
